import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { experienciasApi } from '../../api/experiencias'
import { colors, font } from '../../design/tokens'
import { Titulo, BotonPrimario, ErrorBox } from './comunes'

// Alta de una experiencia desde el celular (Martin, 31 ago 2026): pegás el
// texto del evento (el flyer, el mail, lo que sea), la IA lo reparte en los
// campos, ajustás lo que haga falta y se crea SIN publicar (publicar_desde
// vacío). La foto y el armado fino se terminan en el escritorio.
export default function MovilExperienciaNueva() {
  const navigate = useNavigate()
  const [texto, setTexto] = useState('')
  const [campos, setCampos] = useState(null)
  const [ocupado, setOcupado] = useState(false)
  const [error, setError] = useState(null)
  const [creada, setCreada] = useState(null)

  const interpretar = async () => {
    if (!texto.trim()) { setError('Pegá el texto del evento primero.'); return }
    setOcupado(true); setError(null)
    try {
      const { data } = await experienciasApi.interpretar(texto)
      setCampos({
        tipo: data.tipo || 'cena',
        titulo: data.titulo || '',
        fecha_evento: data.fecha_evento || '',
        lugar: data.lugar || '',
        precio: data.precio ?? '',
        cupos: data.cupos ?? '',
        resumen: data.resumen || '',
        cuando_texto: data.cuando_texto || '',
      })
    } catch (e) {
      setError(e.response?.data?.message || 'No se pudo interpretar el texto')
    } finally { setOcupado(false) }
  }

  const crear = async () => {
    setOcupado(true); setError(null)
    try {
      const payload = { ...campos }
      if (payload.precio === '') delete payload.precio
      if (payload.cupos === '') delete payload.cupos
      if (payload.fecha_evento === '') delete payload.fecha_evento
      const { data } = await experienciasApi.crear(payload)
      setCreada(data)
    } catch (e) {
      const errs = e.response?.data?.errors
      setError(errs ? Object.values(errs).flat().join(' ') : (e.response?.data?.message || 'No se pudo crear'))
    } finally { setOcupado(false) }
  }

  if (creada) {
    return (
      <div>
        <Titulo>Experiencia creada</Titulo>
        <p style={{ fontSize: 14, fontFamily: font.sans, color: colors.text, lineHeight: 1.6 }}>
          ✓ <b>{creada.titulo}</b> quedó creada <b>sin publicar</b>, con su artículo {creada.sku ? <span style={{ fontFamily: font.mono }}>{creada.sku}</span> : 'EVENTO-'}.
          La foto y la publicación se terminan desde el escritorio (Web → Experiencias).
        </p>
        <BotonPrimario onClick={() => { setCreada(null); setCampos(null); setTexto('') }}>＋ Otra experiencia</BotonPrimario>
        <button style={btnSec} onClick={() => navigate('/m')}>← Volver al inicio</button>
      </div>
    )
  }

  return (
    <div>
      <Titulo>Nueva experiencia</Titulo>
      {!campos ? (
        <>
          <p style={hint}>Pegá el texto del evento (flyer, mail, WhatsApp) y la IA lo reparte en los campos.</p>
          <textarea
            value={texto} onChange={(e) => setTexto(e.target.value)} rows={9}
            placeholder="Ej: Cena maridaje en LE8 el jueves 17/9 21hs, 5 pasos con vinos de guarda, $180.000 por persona, cupo 24…"
            style={area}
          />
          <BotonPrimario onClick={interpretar} disabled={ocupado} style={{ marginTop: 10 }}>
            {ocupado ? 'Interpretando…' : '✨ Interpretar con IA'}
          </BotonPrimario>
        </>
      ) : (
        <>
          <Campo label="Tipo (cena, evento, viaje…)" v={campos.tipo} on={(v) => setCampos({ ...campos, tipo: v })} />
          <Campo label="Título" v={campos.titulo} on={(v) => setCampos({ ...campos, titulo: v })} />
          <Campo label="Fecha (AAAA-MM-DD)" v={campos.fecha_evento} on={(v) => setCampos({ ...campos, fecha_evento: v })} mono />
          <Campo label="Cuándo (texto)" v={campos.cuando_texto} on={(v) => setCampos({ ...campos, cuando_texto: v })} />
          <Campo label="Lugar" v={campos.lugar} on={(v) => setCampos({ ...campos, lugar: v })} />
          <Campo label="Precio por persona" v={campos.precio} on={(v) => setCampos({ ...campos, precio: v })} mono />
          <Campo label="Cupos" v={campos.cupos} on={(v) => setCampos({ ...campos, cupos: v })} mono />
          <label style={lbl}>Resumen</label>
          <textarea value={campos.resumen} onChange={(e) => setCampos({ ...campos, resumen: e.target.value })} rows={4} style={area} />
          <BotonPrimario onClick={crear} disabled={ocupado || !campos.titulo} style={{ marginTop: 10 }}>
            {ocupado ? 'Creando…' : 'Crear (sin publicar)'}
          </BotonPrimario>
          <button style={btnSec} onClick={() => setCampos(null)}>← Volver al texto</button>
        </>
      )}
      {error && <ErrorBox>{error}</ErrorBox>}
    </div>
  )
}

function Campo({ label, v, on, mono }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <label style={lbl}>{label}</label>
      <input value={v ?? ''} onChange={(e) => on(e.target.value)} style={{ ...input, fontFamily: mono ? font.mono : font.sans }} />
    </div>
  )
}

const hint = { fontSize: 13, color: colors.textSec, fontFamily: font.sans, margin: '4px 0 10px', lineHeight: 1.5 }
const area = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 12, border: `1px solid ${colors.textPlh}`, fontSize: 14, fontFamily: font.sans, outline: 'none', resize: 'vertical' }
const input = { width: '100%', boxSizing: 'border-box', padding: '9px 12px', borderRadius: 10, border: `1px solid ${colors.textPlh}`, fontSize: 14, outline: 'none' }
const lbl = { display: 'block', fontSize: 11.5, color: colors.textSec, fontFamily: font.sans, fontWeight: 600, marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.04em' }
const btnSec = { marginTop: 8, padding: '10px 0', width: '100%', borderRadius: 12, border: `1px solid ${colors.border}`, background: colors.bg, color: colors.textSec, fontSize: 13, fontWeight: 600, fontFamily: font.sans, cursor: 'pointer' }
